<bz-dialog-layout [heading]="'Mondelez Summary Report' | translate" [dismissible]="true">

  <div bzDialogContent class="layout-column timecard-dialog-body" appBringozIdGenerator="mondelezSummaryDialog">
    <div class="br-body-1">{{ 'TIMEKEEPING_MONDELEZ_SUMMARY_DISCLAIMER' | translate }}</div>

    <div class="timecard-dialog-row">
      <bz-button variant="outline" tone="primary" appBringozIdGenerator="calendarWeekBtn" (clicked)="selectCalendarWeek()">
        {{ 'Calendar Week' | translate }}
      </bz-button>
      <bz-button variant="outline" tone="primary" appBringozIdGenerator="previousWeekBtn" (clicked)="selectPreviousWeek()">
        {{ 'Previous Week' | translate }}
      </bz-button>
    </div>

    <div class="timecard-dialog-row">
      <app-bringoz-date-picker class="flex"
                               [date]="from()"
                               [maxDate]="to()"
                               [placeholder]="'From'"
                               (onChange)="onFromChange($event)">
      </app-bringoz-date-picker>
      <app-bringoz-date-picker class="flex"
                               [date]="to()"
                               [minDate]="from()"
                               [placeholder]="'To'"
                               (onChange)="onToChange($event)">
      </app-bringoz-date-picker>
    </div>
  </div>

  <div bzDialogActions>
    <bz-button variant="tertiary" appBringozIdGenerator="cancelBtn" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <bz-button tone="secondary" appBringozIdGenerator="generateBtn" [disabled]="invalid()" (clicked)="onGenerate()">
      {{ 'Generate' | translate }}
    </bz-button>
  </div>

</bz-dialog-layout>
